export default {
    exploreList: [],
    exploreListLimit: 10,
    exploreListOffset: 0,
    exploreListFetchCompleted: false
}